/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left-otg-black': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" _fill="none" d="M0 0h24v24H0z"/><path pid="1" d="M14.53 7.53a.75.75 0 00-1.06-1.06l-5 5a.75.75 0 000 1.061l5 5a.75.75 0 001.06-1.061L10.06 12z" _fill="#141124"/>'
  }
})
